<select (change)="changeTableSize($event.target.value)">
    <option value="20">20</option>
    <option value="50">50</option>
    <option value="100">100</option>
</select>